import * as React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import * as Redux from 'redux';
import { connect } from 'react-redux';

const Logo = styled.div`
    text-align: center;
    max-height: 35px;
    max-width: 200px;
`;

const StyledImg = styled.img`
    height: 100%;
    width: 'auto';
    max-height: 35px;
    max-width: 200px;
`;

export const CustomerLogo = ({ t, logo, defaultLogo }) => {
    return (
        <Logo>
            <StyledImg 
                src={logo !== null && logo.length !== 0 ? `${"data:image/*;base64," + logo}` : defaultLogo}
                alt={t('There is no logo for this customer')}>
            </StyledImg>
        </Logo>
    );
}

const mapStateToProps = state => ({  
    defaultLogo: state.domainProperties.get('darkLogo'),  
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(CustomerLogo));


// WEBPACK FOOTER //
// ./src/containers/content/logo/CustomerLogo.jsx